import { Module, Action, getModule } from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import PageEntity from '@/store/pageEntity';
import {
    getList,
    // removeEntity
} from '@/api/crud';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import {Images} from "@/models/images";

export const MODULE_NAME = Images.moduleName;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class ImagesModule extends PageBaseModule {

    constructor(module: ImagesModule) {
        super(module);

        const page = new PageEntity();
        page.setTitle(Images.listTitle);
        page.setTitleAdd(Images.createTitle);
        page.values.actionPagination = 'images/updatePage';
        page.values.actionPageAmountItems = 'images/updatePageAmountItems';
        page.values.pageAmountItems = 50;
        this.pageSettings = page.values;
        this.pageSettings.routeName = `${Images.moduleName}_edit`;
        this.pageSettings.routeParam = `${Images.moduleName}Id`;
    }

    @Action({ rawError: true })
    async init() {
        await this.getList();
    }

    @Action({ rawError: true })
    async delete(id: number | string) {
        try {
            console.log('delete ' + id)
            // await removeEntity(Images.moduleName, id);
            await this.getList();
        } catch (error) {
            if (error.response?.data) {
                ResponseHandlerModule.showNotify({ message: error.response.data, type: 'fail' });

                return;
            }
            ResponseHandlerModule.showNotify({ message: error, type: 'fail' });
        }
    }

    @Action({ rawError: true })
    async getList() {
        try {
            const result = await getList(Images.moduleName, {
                page: this.pageSettings.pageCurrent,
                items: this.pageSettings.pageAmountItems,
            });
            await this.context.dispatch('setList', result.table);
        } catch (error) {
            if (error.response?.data) {
                ResponseHandlerModule.showNotify({ message: error.response.data, type: 'fail' });
                return;
            }
            ResponseHandlerModule.showNotify({ message: error, type: 'fail' });
        }
    }
}

export default getModule(ImagesModule);